import { all } from "redux-saga/effects";
import { dotThiSaga } from "./dotThiSaga";
import { phongThiSaga } from "./phongThiSaga";
import { monThiSaga } from "./monThiSaga";
import { thiSinhSaga } from "./thiSinhSaga";
import { hinhThucThiSaga } from "./hinhThucThiSaga";
import { tuiThiSaga } from "./tuiThiSaga";
import { caThiSaga } from "./caThiSaga";
import { dotDongTuiSaga } from "./dotDongTuiSaga";
import { dsDoiTuongDuThiSaga } from "./dsDoiTuongDuThiSaga";


export default function* toChucThiSagaWrapper() {
  yield all([
    dotThiSaga(),
    phongThiSaga(),
    monThiSaga(),
    thiSinhSaga(),
    hinhThucThiSaga(),
    tuiThiSaga(),
    caThiSaga(),
    dotDongTuiSaga(),
    dsDoiTuongDuThiSaga(),
  ]);
}
